import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Dropdown, Form, Button } from 'semantic-ui-react';

import * as cm_action from 'actions/commons';

const propTypes = {};

const defaultProps = {};

class Sex extends Component {
  constructor(props) {
    super(props);
  }

  sexChange = (e, data) => {
    try {
      const { cmAPI } = this.props;

      cmAPI.sexChange({
        type: 'sex',
        name: 'value',
        value: data.value
      });
    } catch (e) {
      console.log('###### sexChange Error : ', e);
    } finally {
    }
  };

  render() {
    const { label, input } = this.props;
    const options = [
      { value: null, text: '성별' },
      { value: 0, text: '여' },
      { value: 1, text: '남' }
    ];
    return (
      <Form.Field inline>
        <label style={label}>성별</label>
        <Dropdown
          style={input}
          className="sex"
          placeholder="성별"
          selection
          options={options}
          onChange={this.sexChange}
        />
      </Form.Field>
    );
  }
}

Sex.propTypes = propTypes;
Sex.defaultProps = defaultProps;

Sex = connect(
  (state) => ({
    sex: state.commons.sex
  }),
  (dispatch) => ({
    cmAPI: bindActionCreators(
      {
        sexChange: cm_action.ReduxDataSet
      },
      dispatch
    )
  })
)(Sex);

export default Sex;
